// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M10.465 3.25967L10.915 1.58545L9.24046 2.03415C3.9058 3.46357 0.739977 8.94694 2.1694 14.2816C2.21958 14.4689 2.33295 14.7676 2.4099 14.9662C2.45296 15.0772 2.49364 15.1797 2.52348 15.2542L2.82731 16.0001H8.7L11.9993 13.8L15.3 16.0001H20.6173L20.8937 15.4473C21.4381 14.3586 21.7502 13.3323 21.8128 12.2988L21.9163 10.5877L20.3758 11.3398C19.9773 11.5344 19.5538 11.694 19.1078 11.8135C15.3735 12.8141 11.5352 10.598 10.5346 6.86378C10.1951 5.59695 10.165 4.37554 10.465 3.25967Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9.30278 20.0002H1V18.0002H8.69722L12 15.7983L15.3028 18.0002H23V20.0002H14.6972L12 18.202L9.30278 20.0002Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-moon-rising-filled')
export default class MoonRisingFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'moon-rising-filled',
    }
  }
}
